module.exports = __webpack_public_path__ + "img/app_title.a222bcd8.png";